import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaPriceComponent} from './la-price.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LaTextInputModule} from '../text-input/la-text-input.module';

// Export module's public API
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LaTextInputModule.forRoot()
  ],
  declarations: [LaPriceComponent],
  exports: [LaPriceComponent]
})
export class LaPriceModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaPriceModule,
      providers: []
    }
  }
}
